import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/store/user.module'
import auth from '@/store/auth.module'
import immo from '@/store/immo.module'
import customer from '@/store/customer.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    immo,
    customer
  },
  state: {},
  mutations: {},
  actions: {}
})
